import React, { memo } from "react"
import imgCustomers from "../images/about/customers.png"
import imgPartner from "../images/about/partner.png"
import imgListen from "../images/about/listen.png"
import imgValue from "../images/about/value.png"

const Whyus = () => {
  return (
    <section className="wy-section">
      <div className="wy-inner">

        <div className="wy-left">
          <h2 className="wy-heading">Our core values stand as pillars guiding our every endeavor</h2>
        </div>

        <div className="wy-right">

          <div className="wy-tile wy-tile--1">
            <div className="wy-tile__icon"><img src={imgCustomers} alt="Happy Customer" /></div>
            <div className="wy-tile__label">Happy Customer</div>
            <p className="wy-tile__text">
              We believe that a Happy Customer isn't just a goal — it's the outcome
              of our dedication to treating each interaction as a chance to exceed
              expectations.
            </p>
          </div>

          <div className="wy-tile wy-tile--2">
            <div className="wy-tile__icon"><img src={imgPartner} alt="Customer as Partner" /></div>
            <div className="wy-tile__label">Customer as Partner</div>
            <p className="wy-tile__text">
              Embracing the Customer as a Partner, we collaborate closely, valuing
              their insights as catalysts for mutual growth.
            </p>
          </div>

          <div className="wy-tile wy-tile--3">
            <div className="wy-tile__icon"><img src={imgListen} alt="Everyone Should Be Heard" /></div>
            <div className="wy-tile__label">Everyone Should Be Heard</div>
            <p className="wy-tile__text">
              At our core, we ensure every voice matters, contributing to our
              collective success.
            </p>
          </div>

          <div className="wy-tile wy-tile--4">
            <div className="wy-tile__icon"><img src={imgValue} alt="Continual Value Addition" /></div>
            <div className="wy-tile__content">
              <div className="wy-tile__label">Continual Value Addition</div>
              <p className="wy-tile__text">
                Continual Value Addition is our commitment, driving us to innovate,
                refine, and deliver exceptional solutions that make a tangible
                difference. These values are not just principles — they're the
                essence of who we are and what we stand for.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}
export default memo(Whyus)
